import React from 'react';

export default function MarcoNormativo() {
  return (
    <section className="max-w-4xl mx-auto p-6 bg-white rounded-2xl shadow-sm">
      <header className="mb-4 mt-4">
        <h4 className="text-2xl font-bold">NUESTRO MARCO NORMATIVO Y DOCTRINARIO DE COOPMULMAG</h4>
        <p className="mt-2 text-gray-700">
          La Constitución Política de Colombia define la organización de la Nación como un Estado Social de
          Derecho, que protege y promueve las formas asociativas y solidarias, estructurando y promoviendo la
          Educación como un derecho y deber, para fortalecer y estimular el desarrollo humano y empresarial.
          Igualmente existen una serie de instancias y reglamentaciones que articulan las acciones necesarias
          para lograr los objetivos propuestos:
        </p>
      </header>

      <div className="space-y-3">
        <article className="p-4 rounded-lg border">
          <h4 className="font-semibold">LEY 79 DE 1988</h4>
          <p className="text-gray-700 mt-1">En su Artículo 88, señala la obligación de la Cooperativa, de realizar de modo permanente programas de formación para los Asociados y Colaboradores, en los principios, métodos y características del cooperativismo, así como para los administradores, en la gestión empresarial propia. Regula los organismos de integración y las instituciones auxiliares y de la Educación Cooperativa. Prevé la creación y funcionamiento de los Comités de Educación.</p>
        </article>

        <article className="p-4 rounded-lg border">
          <h4 className="font-semibold">LEY 454 DE 1998</h4>
          <p className="text-gray-700 mt-1">En los Artículos 4 y 5, define qué es Economía Solidaria, sus principios, fines, características, proyecciones y organismos para su proyección y fomento. Estructura el marco conceptual del desarrollo socio empresarial y la educación solidaria.</p>
        </article>

        <article className="p-4 rounded-lg border">
          <h4 className="font-semibold">DECRETO 2880 DE 2004</h4>
          <p className="text-gray-700 mt-1">Por el cual se reglamenta el artículo 8º de la Ley 863 de 2003.</p>
        </article>

        <article className="p-4 rounded-lg border">
          <h4 className="font-semibold">RESOLUCIÓN 194 DE 2001 DE DANSOCIAL</h4>
          <p className="text-gray-700 mt-1">Por la cual se establecen los fundamentos, criterios, parámetros y requisitos de los procesos de inducción y educación en economía solidaria, y la expedición de los certificados de acreditación sobre educación en teoría y práctica de la misma.</p>
        </article>

        <article className="p-4 rounded-lg border">
          <h4 className="font-semibold">LEY 788 DE 2002 (REFORMA TRIBUTARIA)</h4>
          <p className="text-gray-700 mt-1">Por la cual se expiden normas en materia tributaria y penal del orden nacional y territorial; y se dictan otras disposiciones.</p>
        </article>

        <article className="p-4 rounded-lg border">
          <h4 className="font-semibold">LEY 1819 DE 2016</h4>
          <p className="text-gray-700 mt-1">Por medio de la cual se adopta una reforma tributaria estructural, se fortalecen los mecanismos para la lucha contra la evasión y la elusión fiscal, y se dictan otras disposiciones.</p>
        </article>

        <article className="p-4 rounded-lg border">
          <h4 className="font-semibold">RESOLUCIÓN 221 DE 2007 DE DANSOCIAL</h4>
          <p className="text-gray-700 mt-1">Por la cual se regulan los fundamentos, criterios, parámetros y requisitos para otorgar aval al programa de educación solidaria con énfasis en trabajo asociado.</p>
        </article>

        <article className="p-4 rounded-lg border">
          <h4 className="font-semibold">RESOLUCIÓN 426 DE 2008 DE DANSOCIAL</h4>
          <p className="text-gray-700 mt-1">Por la cual se establecen los fundamentos, criterios, parámetros y requisitos para impartir cursos de inducción y educación en economía solidaria, y la expedición de los certificados de acreditación sobre educación en teoría y práctica de la misma.</p>
        </article>

        <article className="p-4 rounded-lg border">
          <h4 className="font-semibold">CIRCULAR BÁSICA JURÍDICA 2015</h4>
          <p className="text-gray-700 mt-1">Sustituye y deroga la Circular Básica Jurídica 007 de 2008.</p>
        </article>
      </div>

      </section>
  );
}
